import { render, staticRenderFns } from "./UserHelp.vue?vue&type=template&id=d79352fa&scoped=true&"
import script from "./UserHelp.vue?vue&type=script&lang=js&"
export * from "./UserHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79352fa",
  null
  
)

export default component.exports